import { motion } from "framer-motion";
import OutlineHeading from "../ui/outlineHeading";
import Image from "next/image";
import HoloCard from "./holoCard";

const laws = [
  {
    highlight: "no human fingerprints",
    description:
      "The cat's technology births every token—no human fingerprints here.",
  },
  {
    highlight: "fierce arena of approval or rejection",
    description:
      "The community judges them, a fierce arena of approval or rejection.",
  },
  {
    highlight: "survival is the only currency",
    description:
      "One token emerges victorious each round—survival is the only currency.",
  },
  {
    highlight: "engagement, volume, viability",
    description:
      "Winners face the DNA trial—engagement, volume, viability—or face elimination.",
  },
  {
    highlight: "no mercy, no second chances",
    description: "Weak DNA is destroyed—no mercy, no second chances.",
  },
  {
    highlight: "scarred but proud",
    description: "The fierce hold the leaderboard, scarred but proud.",
  },
  {
    highlight: "seeding the next battle",
    description:
      "Victors earn the right to reproduce, seeding the next battle.",
  },
  {
    highlight: "infused with new hunger",
    description: "Offspring inherit the legacy, infused with new hunger.",
  },
  {
    highlight: "jagged lineage in the blockchain",
    description:
      "The cycle continues, carving a jagged lineage in the blockchain.",
  },
  {
    highlight: "sharpens its edge with each clash",
    description:
      "Evolution never pauses; it sharpens its edge with each clash.",
  },
];

export default function TokenLawsSection() {
  return (
    <div className="relative bg-transparent text-white overflow-hidden py-2 md:py-24 p-2 md:p-6">
      <div className="absolute inset-0 z-0">
        <div className="w-full h-full bg-transparent" />
        <div className="absolute top-1/2 left-1/2 w-[500px] h-[500px] bg-gradient-to-r from-indigo-500 to-pink-500 blur-3xl opacity-20 rounded-full transform -translate-x-1/2 -translate-y-1/2 animate-pulse" />
      </div>
      <OutlineHeading className="mb-8 lg:max-w-screen-xl w-full  lg:text-6xl font-extrabold text-center uppercase tracking-widest">
        CatDevAI: Laws of the Untamed Forge
      </OutlineHeading>
      <HoloCard className="relative z-10 mx-auto text-center max-w-screen-lg rounded-2xl">
        <motion.h3
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.3 }}
          className="text-xl md:text-2xl w-full text-center text-purple-400 font-semibold tracking-wider"
        >
          Darwin&apos;s cat lives by its own fierce code
        </motion.h3>

        <div className="flex flex-col md:flex-row justify-between w-full items-center ">
          {" "}
          <motion.ul
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.3 }}
            className=" text-indigo-100 text-justify  space-y-1 md:space-y-2"
          >
            {laws.map((law, idx) => (
              <li key={idx} className="list-disc ml-2 md:ml-8">
                <p className="space-y-0 md:space-y-2 text-base md:text-lg">
                  {law.description
                    .replace(
                      law.highlight,
                      `<span class=''>${law.highlight}</span>`
                    )
                    .split(/(<[^>]+>[^<]+<\/[^>]+>)/g)
                    .map((part, i) =>
                      part.startsWith("<span") ? (
                        <span
                          key={i}
                          dangerouslySetInnerHTML={{ __html: part }}
                        />
                      ) : (
                        <span key={i}>{part}</span>
                      )
                    )}
                </p>
              </li>
            ))}
          </motion.ul>
          <div className="animate-floatbottomright mb-10 lg:flex hidden">
            <Image
              className="h-auto w-full max-h-80 "
              src={"/docs/cat-coin.png"}
              alt="cat token"
              height={400}
              width={400}
            />
          </div>
        </div>
      </HoloCard>
    </div>
  );
}
